/*
 * THE CALENDAR (2026-10-08): every holiday's next date, the last day to order for it, and today's star sign. ONE copy
 * for the whole site, as window.PP_CAL. layout/theme.liquid loads it in the head, before every other script, and these
 * read it: the occasions (assets/rd-finding.js holiday(), so the occasions page, an occasion's order-by line and the
 * card list), the homepage (home-spotlights.js: the chip under the search box, the postcards box, the star-sign
 * wheel), a series page (rd-series.js, Zodiac's "This month") and the nav's Holidays column (rd-shell.js). The homepage
 * mock inlines this file (venture repo, projects/pop-cards/design-brief/homepage-spotlights/build.mjs), so the mock
 * and the site count the same days. Tested by tests/rd-calendar.test.mjs (node tests/rd-calendar.test.mjs).
 *
 * A HOLIDAY'S DATE IS ALWAYS ITS NEXT ONE, ON OR AFTER TODAY: on 26 December, Christmas is next year's. Until
 * 2026-10-08 each holiday had one fixed date (the occasion guide's, Halloween 2026 to Rosh Hashanah 2027) and a passed
 * one stayed "Passed for this year", so from October 2027 every holiday on the site would have read as passed.
 *   fixed     Halloween, Christmas, Kwanzaa (its first day), New Year, Valentine's Day, St Patrick's Day, Fourth of July
 *   by rule   Thanksgiving, the 4th Thursday of November. Mother's Day, the 2nd Sunday of May. Father's Day, the 3rd
 *             Sunday of June. Grandparents Day, the Sunday after Labor Day (the 1st Monday of September). Easter
 *             (Western), the Gregorian computus (the anonymous algorithm, as in Meeus, Astronomical Algorithms).
 *   by table  the lunisolar ones: exact dates, each checked on 2026-10-08 against
 *             Diwali (Lakshmi Puja), 2026-2033: Drik Panchang's Diwali calendar for New York City (drikpanchang.com,
 *               diwali-puja-calendar.html?geoname-id=5128581, one year at a time). These are the US dates; India's are
 *               a day later in 2027, 2030 and 2031.
 *             Hanukkah, Passover, Rosh Hashanah, 2026-2035: Hebcal (hebcal.com/hebcal, major holidays, by year). The
 *               FIRST EVENING's civil date, as the occasion guide always had it: the first candle, Erev Pesach (the
 *               first seder), Erev Rosh Hashana.
 *             Lunar New Year, 2026-2035: the first day of the lunar year (vclock.com's Chinese New Year pages; the
 *               same dates as every other table we found).
 *             A year past the end of its table has no date: that holiday then shows no date and no order-by line,
 *             never a wrong one, and the occasions page leaves it out of its Holidays. ⚠️ Add the next years before
 *             2033 (Diwali) and 2035 (the others); the test fails a year before a table runs out.
 *
 * THE LAST DAY TO ORDER: seven business days before the last business day before the holiday (cards post the next
 * business day and take 3-7 business days; pop-cards decisions, 2026-10-05). A business day is a weekday that is not a
 * US postal holiday: the federal holidays the Postal Service observes (New Year's Day, Martin Luther King Jr. Day,
 * Presidents Day, Memorial Day, Juneteenth, Independence Day, Labor Day, Columbus Day, Veterans Day, Thanksgiving,
 * Christmas), by rule for any year, a fixed-date one on a Saturday observed the Friday before and on a Sunday the
 * Monday after (the federal rule). Postal holidays counted out since 2026-10-08 (Daniel); until then only weekends
 * were, and New Year 2027 (Christmas Day in its window) and Father's Day 2027 (Juneteenth, observed Friday 18 June)
 * came out a business day late. assets/cards-catalogue.js (the retired All cards prototype) uses this rule too.
 *
 * Dates are the visitor's own local days (midnight), as the occasion pages always counted them.
 */
(function () {
  'use strict';
  const today = () => { const t = new Date(); t.setHours(0, 0, 0, 0); return t; };
  const day = (y, m, d) => new Date(y, m - 1, d);
  // the nth weekday (0 Sunday … 6 Saturday) of a month
  const nth = (y, m, wd, n) => { const d = day(y, m, 1); d.setDate(1 + ((wd - d.getDay() + 7) % 7) + 7 * (n - 1)); return d; };
  function easter(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return day(y, Math.floor(n / 31), (n % 31) + 1);
  }
  const TABLE = {
    diwali: ['2026-11-08', '2027-10-28', '2028-10-17', '2029-11-05', '2030-10-25', '2031-11-13', '2032-11-02', '2033-10-22'],
    hanukkah: ['2026-12-04', '2027-12-24', '2028-12-12', '2029-12-01', '2030-12-20', '2031-12-09', '2032-11-27', '2033-12-16', '2034-12-06', '2035-12-25'],
    'lunar-new-year': ['2026-02-17', '2027-02-06', '2028-01-26', '2029-02-13', '2030-02-03', '2031-01-23', '2032-02-11', '2033-01-31', '2034-02-19', '2035-02-08'],
    passover: ['2026-04-01', '2027-04-21', '2028-04-10', '2029-03-30', '2030-04-17', '2031-04-07', '2032-03-26', '2033-04-13', '2034-04-03', '2035-04-23'],
    'rosh-hashanah': ['2026-09-11', '2027-10-01', '2028-09-20', '2029-09-09', '2030-09-27', '2031-09-17', '2032-09-05', '2033-09-23', '2034-09-13', '2035-10-03'],
  };
  const fromTable = (h) => (y) => { const s = TABLE[h].find((x) => +x.slice(0, 4) === y); return s ? day(y, +s.slice(5, 7), +s.slice(8, 10)) : null; };
  /* Every holiday the site knows, in the order of the year, with the name the site falls back on (the occasion pages
     take theirs from Shopify's occasion metaobjects) and its date in a given year. */
  const HOLIDAYS = [
    ['new-year', 'New Year', (y) => day(y, 1, 1)],
    ['lunar-new-year', 'Lunar New Year', fromTable('lunar-new-year')],
    ['valentines', 'Valentine’s Day', (y) => day(y, 2, 14)],
    ['st-patricks-day', 'St Patrick’s Day', (y) => day(y, 3, 17)],
    ['easter', 'Easter', easter],
    ['passover', 'Passover', fromTable('passover')],
    ['mothers-day', 'Mother’s Day', (y) => nth(y, 5, 0, 2)],
    ['fathers-day', 'Father’s Day', (y) => nth(y, 6, 0, 3)],
    ['fourth-of-july', 'Fourth of July', (y) => day(y, 7, 4)],
    ['grandparents-day', 'Grandparents Day', (y) => { const d = nth(y, 9, 1, 1); d.setDate(d.getDate() + 6); return d; }],
    ['rosh-hashanah', 'Rosh Hashanah', fromTable('rosh-hashanah')],
    ['halloween', 'Halloween', (y) => day(y, 10, 31)],
    ['diwali', 'Diwali', fromTable('diwali')],
    ['thanksgiving', 'Thanksgiving', (y) => nth(y, 11, 4, 4)],
    ['hanukkah', 'Hanukkah', fromTable('hanukkah')],
    ['christmas', 'Christmas', (y) => day(y, 12, 25)],
    ['kwanzaa', 'Kwanzaa', (y) => day(y, 12, 26)],
  ].map(([h, name, on]) => ({ h, name, on }));
  const BY = {};
  HOLIDAYS.forEach((x) => { BY[x.h] = x; });

  /* The holiday's next date on or after `from` (default today), or null when its table has run out. */
  function next(h, from) {
    const x = BY[h];
    if (!x) return null;
    const t = from ? new Date(from) : today();
    t.setHours(0, 0, 0, 0);
    for (let y = t.getFullYear(); y <= t.getFullYear() + 1; y += 1) {
      const d = x.on(y);
      if (d && d >= t) return d;
    }
    return null;
  }
  // The postal holidays of a year (see the top). A Saturday New Year's Day is observed on 31 December of the year before.
  const observed = (d) => { if (d.getDay() === 6) d.setDate(d.getDate() - 1); else if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; };
  const lastMonday = (y, m) => { const d = day(y, m + 1, 0); d.setDate(d.getDate() - ((d.getDay() + 6) % 7)); return d; };
  const postalOf = (y) => [observed(day(y, 1, 1)), nth(y, 1, 1, 3), nth(y, 2, 1, 3), lastMonday(y, 5), observed(day(y, 6, 19)), observed(day(y, 7, 4)),
    nth(y, 9, 1, 1), nth(y, 10, 1, 2), observed(day(y, 11, 11)), nth(y, 11, 4, 4), observed(day(y, 12, 25))];
  const ymd = (d) => d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  const POSTAL = {};
  function isPostal(d) {
    const y = d.getFullYear();
    [y, y + 1].forEach((x) => { if (!POSTAL[x]) POSTAL[x] = new Set(postalOf(x).map(ymd)); });
    return POSTAL[y].has(ymd(d)) || POSTAL[y + 1].has(ymd(d));
  }
  const isBiz = (d) => d.getDay() > 0 && d.getDay() < 6 && !isPostal(d);
  function orderBy(date) {
    const x = new Date(date);
    do { x.setDate(x.getDate() - 1); } while (!isBiz(x));
    let n = 7;
    while (n > 0) { x.setDate(x.getDate() - 1); if (isBiz(x)) n -= 1; }
    return x;
  }
  /* One holiday as the site shows it: its next date, its last day to order, and whether that day has gone ("late":
     order today and it may arrive just after). */
  function when(h, from) {
    const d = next(h, from);
    if (!d) return null;
    const t = from ? new Date(from) : today();
    t.setHours(0, 0, 0, 0);
    const ob = orderBy(d);
    return { h, name: BY[h].name, date: d, orderBy: ob, late: t > ob };
  }
  /* Every holiday with a known date, soonest first. */
  const upcoming = (from) => HOLIDAYS.map((x) => when(x.h, from)).filter(Boolean).sort((a, b) => a.date - b.date);
  /* The ones a card ordered today can still reach in time (its last day to order not gone), soonest first; only some
     holidays when `only` lists them. The homepage's chip and postcards box. */
  const inTime = (only, from) => upcoming(from).filter((w) => !w.late && (!only || only.includes(w.h)));
  const fmt = (d, weekday) => d.toLocaleDateString('en-US', weekday === false ? { month: 'short', day: 'numeric' } : { weekday: 'short', month: 'short', day: 'numeric' });

  /* The star signs, Aries first, with the dates every Zodiac card carries. Today's sign: the one whose first day is the
     latest on or before today (Capricorn runs over the new year). */
  const SIGNS = [['Aries', 'Mar 21 – Apr 19', 321], ['Taurus', 'Apr 20 – May 20', 420], ['Gemini', 'May 21 – Jun 20', 521], ['Cancer', 'Jun 21 – Jul 22', 621],
    ['Leo', 'Jul 23 – Aug 22', 723], ['Virgo', 'Aug 23 – Sep 22', 823], ['Libra', 'Sep 23 – Oct 22', 923], ['Scorpio', 'Oct 23 – Nov 21', 1023],
    ['Sagittarius', 'Nov 22 – Dec 21', 1122], ['Capricorn', 'Dec 22 – Jan 19', 1222], ['Aquarius', 'Jan 20 – Feb 18', 120], ['Pisces', 'Feb 19 – Mar 20', 219]];
  function sign(on) {
    const t = on ? new Date(on) : today(), md = (t.getMonth() + 1) * 100 + t.getDate();
    let best = SIGNS[9], at = -1;   // Capricorn, for 1 to 19 January
    SIGNS.forEach((s) => { if (s[2] <= md && s[2] > at) { best = s; at = s[2]; } });
    return { name: best[0], dates: best[1], index: SIGNS.indexOf(best) };
  }

  window.PP_CAL = { today, next, orderBy, when, upcoming, inTime, fmt, sign, isPostal, postal: (y) => postalOf(y), HOLIDAYS: HOLIDAYS.map((x) => ({ h: x.h, name: x.name })),
    SIGNS: SIGNS.map((s) => ({ name: s[0], dates: s[1] })), TABLE };
})();
